import { Request } from '../request';
import { TSubmitKlarityPlanStepInput } from 'types/klarityPlan';

export const klarityPlanStepSubmit = (data: TSubmitKlarityPlanStepInput) => Request.post({ url: '/schedule-server/provider/step/process', params: data });

export const getProviderConnectedChannels = () => Request.get({ url: '/schedule-server/provider/channel/accessInfo/getByProviderId' });
